import axiosInstance from '../utils/axiosConfig';

const BASE = '/api/abacus';

// What IMT's Abacus screens ask the server for. Documents go to Abacus by
// themselves when accounting marks them collected (Accounting Queue); these
// calls only show where they stand and let finance fix what they wait for.
// Reading accounts, VAT codes or the ledger always names the company's books.
const abacusService = {
  healthCheck: async () => (await axiosInstance.get(`${BASE}/health/`)).data,

  getSyncStatus: async () => (await axiosInstance.get(`${BASE}/status/`)).data,

  checkRecordSyncStatus: async (model, id) =>
    (await axiosInstance.get(`${BASE}/sync/check/`, { params: { model, id } })).data,

  sendAgain: async (model, id) =>
    (await axiosInstance.post(`${BASE}/send-again/`, { model, id })).data,

  matchPartner: async (crmId, { books, side, abacus_id: abacusId }) =>
    (await axiosInstance.post(`${BASE}/partners/${crmId}/match/`, { books, side, abacus_id: abacusId })).data,

  getAccounts: async (books) =>
    (await axiosInstance.get(`${BASE}/accounts/`, { params: { books } })).data,

  getTaxcodes: async (books) =>
    (await axiosInstance.get(`${BASE}/taxcodes/`, { params: { books } })).data,

  getTaxRate: async (books, code, asOf = null) => {
    const params = { books, code };
    if (asOf) params.as_of = asOf;
    return (await axiosInstance.get(`${BASE}/taxcodes/rate/`, { params })).data;
  },

  getGLEntries: async (params = {}) =>
    (await axiosInstance.get(`${BASE}/gl/entries/`, { params })).data,

  getAccountBalance: async (books, accountId, dateFrom = null, dateTo = null) => {
    const params = { books, account_id: accountId };
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    return (await axiosInstance.get(`${BASE}/gl/balance/`, { params })).data;
  },
};

export default abacusService;
